// extracted by mini-css-extract-plugin
export default {"accountItem":"AccountItem_accountItem__4Wzar flex flex--row-center","titleUsername":"AccountItem_titleUsername__9lDm4","title":"AccountItem_title__Al4yw"};